<template>
  <div class="feedback-form-button" ref="frame">
    <a href="https://forms.gle/ERTk4bsDzrawxtCa7" target="_blank">アンケート</a>
  </div>
</template>

<script>
export default {
  name: 'FeedbackFormButton',
};
</script>

<style scoped lang="scss">
.feedback-form-button {
  background: rgb(88, 167, 105);

  a {
    display: block;
    padding: 10px;
    text-decoration: none;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/FeedbackFormButton.vue